import { render, staticRenderFns } from "./yb.vue?vue&type=template&id=aa947c06&scoped=true&"
import script from "./yb.vue?vue&type=script&lang=js&"
export * from "./yb.vue?vue&type=script&lang=js&"
import style0 from "./yb.vue?vue&type=style&index=0&lang=less&"
import style1 from "./yb.vue?vue&type=style&index=1&id=aa947c06&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa947c06",
  null
  
)

export default component.exports